import { useCallback } from 'react';
import { useMainStackNavigation } from 'utils/types/navigationV6';
const useNavigateBackAfterSellFromPortfolio = () => {
    const navigation = useMainStackNavigation();
    return useCallback((popCount) => {
        const hasPortfolioRoute = navigation.getState().routes.some((route) => route.name === 'InvestPortfolio');
        const hasInvestStockRoute = navigation.getState().routes.some((route) => route.name === 'InvestStock');
        if (hasPortfolioRoute && !hasInvestStockRoute) {
            navigation.popTo('InvestPortfolio');
        }
        else {
            navigation.pop(popCount);
        }
    }, [navigation]);
};
export { useNavigateBackAfterSellFromPortfolio };
